import { render, staticRenderFns } from "./GlobalSelectionDialog.vue?vue&type=template&id=53158044&scoped=true"
import script from "./GlobalSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./GlobalSelectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53158044",
  null
  
)

export default component.exports